/**
 * Central controller for managing dumbapp inputs for submission.
 */
import Emittery from "emittery";
import { ExecutionStateValueProvider } from "../state";
import { ExecutionController } from "../state";
import { ExecutionArgumentResolver } from "../state";
import { debounce } from "@blockwell/util";
import { CachedContractsLoader } from "./CachedContractsLoader";
import { ApprovalHandler } from "./ApprovalHandler";
export class InputController extends Emittery {
    constructor() {
        super();
        this.values = new ExecutionStateValueProvider();
        this.execution = new ExecutionController();
        this.resolver = new ExecutionArgumentResolver();
        this.contractsLoader = new CachedContractsLoader();
        this.approval = new ApprovalHandler();
        this.dumbapp = null;
        this.account = null;
        this.hidden = true;
        this.doResolve = debounce((values) => {
            this.execution.resolve(values.state)
                .then(async (res) => {
                if (res.success === true) {
                    this.lastResolveResult = {
                        success: true,
                        arguments: res.data.arguments,
                        approve: res.data.state.approve,
                        state: res.data.state,
                        values
                    };
                    this.emit("resolve", this.lastResolveResult);
                }
                else {
                    this.lastResolveResult = res;
                    this.emit("resolve", res);
                }
            });
        });
        this.execution.addHandler("InputController", "prepareRequest", (simulation) => {
            let created = new Date().toISOString();
            if (!this.dumbapp) {
                return {
                    success: false,
                    code: "no_dumbapp",
                    message: "No dumbapp loaded, probably due to misconfiguration.",
                };
            }
            return {
                success: true,
                data: {
                    simulation,
                    dumbapp: this.dumbapp,
                    created,
                    data: [],
                    extras: {}
                },
            };
        });
        this.execution.addHandler("ExecutionArgumentResolver", "resolve", this.resolver.handler);
        this.execution.addHandler("InputController", "loadContracts", this.contractsLoader.handler);
        this.execution.addHandler("ApprovalHandler", "preExecute", this.approval.handler);
    }
    get lastResolve() {
        return this.lastResolveResult;
    }
    update(dumbapp, account) {
        this.dumbapp = dumbapp;
        this.account = account;
        this.hidden = false;
    }
    setApi(api) {
        this.contractsLoader.setApi(api);
        this.approval.setApi(api);
    }
    setHidden(hidden) {
        this.hidden = hidden;
        this.trigger();
    }
    placeholderText() {
        return "Enter a value in the form";
    }
    trigger() {
        if (this.dumbapp && !this.hidden) {
            this.execution.simulate().then((res) => {
                if (res) {
                    this.values.state = res;
                    this.account = res.wallet?.account;
                    this.emit("change", this.values);
                    this.doResolve(this.values);
                }
            });
        }
    }
    resolve() {
        if (this.values.state) {
            this.doResolve(this.values);
        }
    }
}
